import { USER_URL } from "../constant/api";

//fetch all address
export const AddressFetchApi = async () => {
  try {
    const response = await USER_URL.get("accounts/addresses/");
    console.log(response.data);

    return response.data;
  } catch (error) {
    console.log("error in order checkout", error);
    throw error;
  }
};
// add new address
export const AddAddressApi = async (formData) => {
  try {
    const response = await USER_URL.post("accounts/addresses/", formData);

    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log("Error in adding address", error);
    throw error;
  }
};

// edit existing address
export const UpdateAddressApi = async (formData, id) => {
  try {
    const response = await USER_URL.patch(
      `accounts/addresses/${id}/`,
      formData,
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log("Error in adding address", error);
    throw error;
  }
};

//select delivery address 


export const SelectDeliveryAddressApi = async (address) => {
  try {
    const response = await USER_URL.post(
      `/accounts/select-delivery/`,
      address,
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log("Error in adding address", error);
    throw error;
  }
};